import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useQRCodeShare } from './useQRCodeShare';

type UseShareYourPetitionOfflineData = {
	qrCodeValue: string;
	qrCodeDescriptionText: string;
	qrCodeDownloadText: string;
	qrCodeFilename: string;
};
type UseShareYourPetitionOfflineActions = { handleDownload: () => Promise<void> };
type UseShareYourPetitionOfflineReturn = ModelHookResult<
	UseShareYourPetitionOfflineData,
	UseShareYourPetitionOfflineActions
>;

export function useShareYourPetitionOffline(): UseShareYourPetitionOfflineReturn {
	const { translate } = useI18n();
	const qrCodeDescriptionText = translate(
		'corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.qrcode_description_text',
	);
	const qrCodeDownloadText = translate(
		'corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.qrcode_download_link_text',
	);
	const qrCodeFilename = translate(
		'corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.qrcode_filename',
	);

	const shareAction = useQRCodeShare();

	const qrCodeValue = shareAction.shortUrl ?? shareAction.url;
	const handleDownload = useCallback(async () => {
		await shareAction.action();
	}, [shareAction]);

	return {
		data: { qrCodeValue, qrCodeDescriptionText, qrCodeDownloadText, qrCodeFilename },
		actions: { handleDownload },
	};
}
